import React, { useEffect, useRef, useState } from "react";
import ArrowBackIcon from "../.././assets/imgs/arrow-back-left.svg";
import { useNavigate } from "react-router-dom";
import { useSupabaseAuth } from "../../Context/AuthContext/AuthContext";
import { hapticsImpactLight } from "../../lib/utils";
import useFirebaseAnalytics from "../../hooks/useFirabaseAnality";
import { useMixpanel } from "../../../src/Context/MixpanelContext/MixpanelProvider";
import { IonHeader, IonToolbar } from "@ionic/react";
import ChatbotImg from "../../assets/imgs/ai-chat-logo.svg";
import { useRevenueCatAuth } from "../../Context/RevenueCatContext/RevenueCatContext";

export const UserDetails: React.FC = () => {
  const navigate = useNavigate();
  const { logEventAnalytics } = useFirebaseAnalytics();
  const Mixpanel = useMixpanel();
  const { useAuthStore, getProfileForDetails, signupProfile } =
    useSupabaseAuth();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const user = useAuthStore((state: any): any => state.user);
  const appleProfile = useAuthStore((state: any): any => state.appleProfile);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchUserProfile = async () => {
      const user_id = user?.user?.id ? user?.user?.id : user?.id;

      if (user_id) {
        if (user?.user?.app_metadata?.provider === "apple" && appleProfile) {
          setEmail(user?.user?.email || appleProfile.emailApple || "");
          setFirstName(appleProfile?.givenName);
          setLastName(appleProfile?.familyName);
        }

        if (user?.user?.app_metadata?.provider === "google") {
          setEmail(user?.user?.email || "");
          setFirstName(user?.user?.user_metadata?.full_name || "");
        }

        const profile = await getProfileForDetails(user_id);

        if (profile) {
          if (profile.user_email) {
            setEmail(profile.user_email || "");
          }

          if (profile.first_name) {
            setFirstName(profile.first_name || "");
          }

          if (profile.last_name) {
            setLastName(profile.last_name || "");
          }

          if (!profile.first_name && profile.user_name) {
            setFirstName(profile.user_name || "");
          }

          if (profile.referral_code) {
            setReferralCode(profile.referral_code || "");
          }
        }
      }
    };

    if (user) {
      fetchUserProfile();
    }
  }, [user]);

  const handleSubmit = async () => {
    console.log("handleSubmit");
    const user_id = user?.user?.id ? user?.user?.id : user?.id;
    console.log(user, "user");
    console.log(user_id, "user_id");
    console.log(firstName, "firstName");
    console.log(lastName, "lastName");
    if (user && user_id && !loading) {
      console.log("call done");
      setLoading(true);
      setErrorMessage(null); // Reset error state before making the call
      try {
        const response = await signupProfile(
          user_id as string,
          firstName,
          lastName,
          email,
          referralCode,
        );
        if (response?.sucess) {
          console.log("chatbot-ai");
          useAuthStore.getState().clearAppleProfile();
          navigate("/chatbot-ai", {
            state: {
              showAnimation: true,
              showPaywall: true,
              checkOnboarding: true,
            },
          });
        } else {
          console.log("error");
          setErrorMessage("Sorry, something went wrong. Please try again.");
        }
      } catch (error) {
        console.log("error on catch");
        setErrorMessage("Sorry, something went wrong. Please try again.");
      }

      setLoading(false);
    }
  };

  const handleGoBack = () => {
    hapticsImpactLight();
    navigate("/welcome");
  };
  const isDisabled = firstName.trim().length === 0;
  const firstNameInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (firstNameInputRef.current) {
      firstNameInputRef.current.focus();
    }
    Mixpanel.trackEvent("enter_first_name_screen_open", {
      name: "Enter First name Screen Open",
    });
  }, []);
  return (
    <div style={{ backgroundColor: "#000513" }}>
      <>
        <IonHeader className="ion-no-border modal-ion-header">
          <IonToolbar className="custom-toolbar">
            <div className="p-3 flex justify-between items-center sticky top-0 z-50">
              <div
                className="cursor-pointer rounded-[100px] w-[40px] h-[40px] flex justify-center items-center grayBtn"
                onClick={handleGoBack}
              >
                <img src={ArrowBackIcon} alt="" />
              </div>
              <div
                className={`flex items-center justify-center bg-[#141926] rounded-[29px] cursor-pointer w-[90px] h-[35px] 
              ${isDisabled ? "opacity-50 pointer-events-none" : "opacity-100"}`}
                onClick={!isDisabled ? handleSubmit : undefined}
              >
                <span
                  className={`text-[16px] font-medium ${isDisabled ? "text-white/50" : "text-white"}`}
                >
                  Done
                </span>
              </div>
            </div>
          </IonToolbar>
        </IonHeader>

        <div className="flex flex-col h-full relative bottom-4">
          <div className="w-full flex flex-col items-center mt-36 h-screen text-center overflow-hidden">
            <div className="sm:w-1/2 sm:px-10 w-full flex flex-col items-center min-h-[350px]">
              <div className="flex flex-col items-center space-y-3">
                <img
                  src={ChatbotImg}
                  alt="ChatbotImg"
                  className="w-[44px] h-[34px]"
                />
                <div className="font-bold text-white text-[32px]">
                  Your first name
                </div>
                {/* Input Field */}
                <div className="relative w-full max-w-xs">
                  <input
                    type="text"
                    placeholder="Enter your first name"
                    value={firstName}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                      setErrorMessage(null); 
                    }}
                    className="w-full px-3 py-2 text-[15px] text-white bg-transparent focus:outline-none placeholder-white/50 text-center"
                    ref={firstNameInputRef}
                  />
                </div>

                {errorMessage && (
                  <div className="mt-10 sm:ml-10 w-full flex flex-col items-center">
                    <p className="text-red-500 mt-4">
                      {errorMessage}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};
